import React, { Component } from "react"
import DropdownButton from "react-bootstrap/lib/DropdownButton"
import MenuItem from "react-bootstrap/lib/MenuItem"
import Avatar from "../avatar"
import Timer from "../timer"
import DashboardSelector from "../dashboard_selector"
import PlusIcon from "../../images/add-circle.svg"
import Logo from "../logo"
import TeamEditModal from "../modals/team_edit_modal"
import PasswordModal from "../modals/password_modal"
import PaymentModal from "../modals/payment_modal"
import { isLoggedIn } from "../../util/jwt_utils"
import { TUTORIAL_URL } from "../../common/constants/app_consts"
import { getDaysUntilEnd } from "../../util/time_utils"
import { appStrings } from "../../common/strings/app_strings"
import { createUserPlan } from "../../util/billing_info_utils"
import TeamSigil from "../team_sigil"
import pkg from "../../../package.json"
import { isElectron } from "../../util/electron_ipc"
import { isTeamAdmin } from "../../util/team_utils"

const {
    trialExpired,
    leftInTrial,
    upgrade,
    trialExpiresToday,
} = appStrings.topNav

class TopNav extends Component {
    constructor(props) {
        super(props)
        this.openPasswordModal = this.openPasswordModal.bind(this)
        this.closePasswordModal = this.closePasswordModal.bind(this)
    }

    openPasswordModal() {
        this.props.setUiPwModalOpen(true)
    }

    closePasswordModal() {
        this.props.setUiPwModalOpen(false)
    }

    navigateToPage = page => this.props.history.push(page)

    trialEndIndicator = () => {
        const daysUntilEnd = getDaysUntilEnd(this.props.trialEnd)
        const hasExpired = daysUntilEnd <= 0
        const isExpiringToday = daysUntilEnd <= 1 && daysUntilEnd > 0
        const message = isExpiringToday 
            ? (
                <span>{trialExpiresToday}</span>
            ) : !hasExpired 
                ? (
                    <span>
                        <span className="bold">{Math.floor(daysUntilEnd)} days</span>{" "}
                        &nbsp;
                        {leftInTrial}
                    </span>
                ) : ( <span>{trialExpired}</span> )

        return (
            <div className="top-nav-trial-indicator">
                {message}&nbsp;
                <span
                    className="indicator-link"
                    onClick={() => this.props.setPaymentModalOpen(true)}
                >
                    {upgrade}
                </span>
            </div>
        )
    }

    render() {
        const {
            teams,
            onNewTimeEntry,
            onStartTimer,
            profile,
            signOut,
            changePassword,
            tags,
            timeEntries,
            runningTimeEntries,
            editTimeEntry,
            stopTimeEntry,
            selectTeam,
            selectedTeamId,
            createTeam,
            editTeam,
            teamModalVisible,
            closeTeamModal,
            editTeamId,
            putTeam,
            ui: { pwModalOpen, paymentModalOpen },
            isMobile,
            history,
            paymentStatus,
            navigateToSettingsPage,
            account,
            trialEnd,
            customer,
            handleChangePaymentMethod,
            handleSetName,
            isNameValid,
            handleStripeToken,
            isLoading,
            setPaymentModalOpen,
            sendBulkInvites,
        } = this.props

        const {
            personalTeamId,
            email: { address },
            name,
            onboardingStep,
            teamMembers,
        } = profile
        const alwaysFree = (account && account.alwaysFree) || false

        const team = teams.find(t => t.id === selectedTeamId)
        const isPersonalTeamSelected = team && team.isPersonal
        const avatar = (
            <div>
                {isMobile 
                    ? (
                        <div className="btn-team btn-team-mobile">
                            {TeamSigil(team)}
                            <p className="mobile-team-name">
                                {isPersonalTeamSelected
                                    ? "Personal"
                                    : (team && team.name) || ""}
                            </p>
                            <i
                                className="fa fa-team-menu-icon"
                                aria-hidden="true"
                            />
                        </div>
                    ) : ( <Avatar emailAddress={address} name={name} />)
                }
            </div>
        )
        const loggedIn = isLoggedIn()

        if (onboardingStep !== "done" || !loggedIn) {
            return (
                <div className="top-nav logged-out">
                    <Logo />
                    {versionNumber()}
                </div>
            )
        }
        // if there is a trialEnd date, show trial end indicator
        const showTrialIndicator = !!trialEnd
        const paymentPlan = createUserPlan(customer.stripePlan)

        // compute teams
        const personalTeam = teams.find(t => t.id === personalTeamId)
        const otherTeams = teams.filter(t => t.id !== personalTeamId)

        return (
            <div className="top-nav-wrapper">
                {showTrialIndicator && this.trialEndIndicator()}
                <div className="top-nav">
                    <div className="top-nav-left">
                        {!isMobile && (
                            <DashboardSelector
                                personalTeam={personalTeam}
                                otherTeams={otherTeams}
                                teams={teams}
                                personalTeamId={personalTeamId}
                                onChange={selectTeam}
                                selectedTeamId={selectedTeamId}
                                createTeam={createTeam}
                                editTeam={editTeam}
                                profile={profile}
                                history={history}
                            />
                        )}
                    </div>
                    <Logo />
                    <div className="top-nav-right">
                        <button
                            onClick={() => onNewTimeEntry()}
                            className="btn btn-default btn-new-entry"
                        >
                            <i className="fa fa-list-alt" aria-hidden="true" />{" "}
                            New Entry
                        </button>
                        <Timer
                            tags={tags}
                            teams={teams}
                            timeEntries={timeEntries}
                            profile={profile}
                            runningTimeEntries={runningTimeEntries}
                            editTimeEntry={editTimeEntry}
                            stopTimeEntry={stopTimeEntry}
                            newTimeEntry={() => onStartTimer()}
                            isMobile={isMobile}
                        />

                        <DropdownButton
                            id="user-menu"
                            title={avatar}
                            pullRight
                            noCaret
                            bsStyle="default"
                            className={`btn btn-avatar ${showTrialIndicator &&
                                "has-trial-indicator"}`}
                        >
                            <MenuItem
                                onClick={() => navigateToSettingsPage(history)}
                            >
                                Settings
                            </MenuItem>
                            <li>
                                <a
                                    className="tutorial-menu-item"
                                    role="presentation"
                                    href={TUTORIAL_URL}
                                    target="_blank"
                                >
                                    Tutorials
                                </a>
                            </li>
                            <MenuItem id="sign-out-menu-item" onClick={signOut}>
                                Sign Out
                            </MenuItem>
                            {versionNumber()}
                            {/* If mobile, show team selector in dropdown */}
                            {/* TODO: DRY code w/ dashboard_selector after implementing fragments */}
                            {isMobile && (
                                <li role="separator" className="divider" />
                            )}
                            {isMobile && personalTeam && (
                                <MenuItem
                                    key={personalTeam.id}
                                    onClick={() => selectTeam(personalTeamId)}
                                    className="cog-icon-container"
                                >
                                    <div className="option-team-wrapper">
                                        Personal
                                    </div>
                                </MenuItem>
                            )}
                            {isMobile &&
                                otherTeams
                                    .sort((a, b) =>
                                        a.name === b.name
                                            ? 0
                                            : a.name > b.name
                                                ? 1
                                                : -1,
                                    )
                                    .map(team => {
                                        if (!team) {
                                            return <div />
                                        }
                                        return (
                                            <MenuItem
                                                key={team.id}
                                                className="cog-icon-container"
                                                onClick={() =>
                                                    selectTeam(team.id)
                                                }
                                            >
                                                <div className="option-team-wrapper">
                                                    <div className="option-team-sigil-wrapper">
                                                        {TeamSigil(team)}
                                                        <p className="option-team-name">
                                                            {team.name}
                                                        </p>
                                                    </div>
                                                    {
                                                        isTeamAdmin(team.id, profile) && (
                                                            <i
                                                                onClick={() =>
                                                                    editTeam(
                                                                        team.id,
                                                                    )
                                                                }
                                                                className="fa fa-cog fa-lg"
                                                            />
                                                        )
                                                    }
                                                </div>
                                            </MenuItem>
                                        )
                                    })}
                            {isMobile && (
                                <li role="separator" className="divider" />
                            )}
                            {isMobile && (
                                <MenuItem
                                    key={"__NEW_TEAM__"}
                                    eventKey={"close-dropdown"}
                                    onClick={() => editTeam("")}
                                    className="cog-icon-container"
                                >
                                    <div className="option-team-wrapper">
                                        New Team
                                    </div>
                                </MenuItem>
                            )}
                        </DropdownButton>
                    </div>

                    {teamModalVisible && (
                        <TeamEditModal
                            setPaymentModalOpen={setPaymentModalOpen}
                            accountName={account.name}
                            teams={teams}
                            editTeamId={editTeamId}
                            createTeam={createTeam}
                            personalTeamId={personalTeamId}
                            selectTeam={selectTeam}
                            profile={profile}
                            closeTeamModal={closeTeamModal}
                            putTeam={putTeam}
                            trialEnd={trialEnd}
                            alwaysFree={alwaysFree}
                            paymentStatus={paymentStatus}
                            history={this.props.history}
                            sendBulkInvites={sendBulkInvites}
                        />
                    )}

                    {pwModalOpen && (
                        <PasswordModal
                            changePassword={changePassword}
                            pwModalOpen={pwModalOpen}
                            closePasswordModal={this.closePasswordModal}
                        />
                    )}
                    {paymentModalOpen && (
                        <PaymentModal
                            handleChangePaymentMethod={
                                handleChangePaymentMethod
                            }
                            paymentModalOpen={paymentModalOpen}
                            name={name}
                            handleSetName={handleSetName}
                            isNameValid={isNameValid}
                            customer={customer}
                            paymentPlan={paymentPlan}
                            teamId={selectedTeamId}
                            handleStripeToken={handleStripeToken}
                            isLoading={isLoading}
                            teamMembers={teamMembers}
                            setPaymentModalOpen={setPaymentModalOpen}
                            isUpgrade={showTrialIndicator}
                            history={history}
                        />
                    )}
                    {isMobile && (
                        <div className="mobile-new-time-entry-container">
                            <button
                                className="mobile-new-time-entry"
                                onClick={() => onNewTimeEntry()}
                            >
                                <img
                                    src={PlusIcon}
                                    alt="Create time entry button"
                                />
                            </button>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default TopNav

const versionNumber = () => {
    const version = pkg.version
    const showVersionNumber = isElectron()
    return (
        showVersionNumber && <span className="version-number">v{version}</span>
    )
}


// WEBPACK FOOTER //
// ./src/components/layout/top_nav.jsx